import qs from 'qs';
import { useQuery, useQueries } from 'react-query';

import { axios } from 'lib';

const getDirectsSupplierFilesCount = (directID, tcID) => {
  return axios.get(
    `/api/directs/${directID}/suppliers/${tcID}/files/count`
  );
};

export const useDirectsSupplierFilesCount = (directID, tcID, options = {}) => {
  return useQuery(
    `direct-supplier-${tcID}-count`,
    () => getDirectsSupplierFilesCount(directID, tcID),
    {
      //@ts-ignore
      initialData: { data: { count: 0 } },
      select: ({ data }) => data,
      ...options,
    }
  );
}

export const useDirectsSupplierFilesCountQueries = (directId, tcIDs, options = {}) => {
  // Use useQueries to create a query for each facId
  const queries = useQueries(
    tcIDs.map(tcID => ({
      queryKey: [`direct-supplier-${tcID}-files-count`, tcID],
      queryFn: () => getDirectsSupplierFilesCount(directId, tcID),
      initialData: { data: { count: 0 } },
      select: ({ data }) => data,
      ...options,
    }))
  );

  return queries;
};
